import { render, staticRenderFns } from "./BetTypeSelectorMarketView.vue?vue&type=template&id=89aaef86"
import script from "./BetTypeSelectorMarketView.vue?vue&type=script&lang=js"
export * from "./BetTypeSelectorMarketView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports